module.exports = __webpack_public_path__ + "static/media/sd.22afffa1.svg";